import React, { useState, useEffect } from "react";
import Pathnames from "../model/enum/Pathnames";
import {
  Spinner,
  Contacts,
  Requests,
  Navbar,
  Appointments,
  Services,
  Overview,
  Clients,
  Gallery,
  Reviews,
  Login,
  Faqs,
  Errors,
  Logs,
  Users,
  UserProfile,
  OverviewTeam,
  Projects,
  ActivationAccount,
  Roles,
  Sidebar,
  Dashboard,
  Estimates,
  DeniedAccess,
  OverviewTag,
  Settings
} from "./index";
import { Route, Routes } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useLocation } from "react-router-dom";
import { SearchProvider } from "../shared/components/search/SearchContext";
import "./Admin.css";

const customStyles = {
  maxWidth: "2200px", // Desired width
};

const Admin = () => {
  //loggedIn user
  const [user, setUser] = useState();
  const [cookies, setCookie] = useCookies(["session"]);

  var accessToken = localStorage.getItem("accessToken");

  const [loading, setLoading] = useState(false);
  const location = useLocation();

  let pathname = location.pathname;

  //Check if user is logged in
  useEffect(() => {
    document.title = "Admin - Setup Remodeling";

    const isAuthenticated = cookies.session && accessToken;
    const isProtectedRoute = allowedPaths();

    if (!isAuthenticated && isProtectedRoute) {
      localStorage.clear();
      setLoading(false);
      window.open(Pathnames.LOGIN, "_self");
    }
  }, [location.pathname]);

  const allowedPaths = (): boolean => {
    return (
      pathname !== Pathnames.LOGIN &&
      pathname !== Pathnames.ACTIVATE_ACCOUNT &&
      pathname.includes("admin")
    );
  };

  return (
    <>
      {loading && <Spinner />}
      <SearchProvider>
        <div className="container" style={customStyles}>
          {allowedPaths() && <Sidebar />}
          <div className="main-area">
            <header className="navbar-content">
              {/* Navbar content */}
              {allowedPaths() && <Navbar />}
            </header>
            <main className="main-content">
              {/* Main content like tables */}
              <Routes>
                <Route path={Pathnames.LOGIN} element={<Login />} />
                <Route path={Pathnames.DASHBOARD} element={<Dashboard />} />
                <Route path={Pathnames.GALLERY_LIST} element={<Gallery />} />
                <Route path={Pathnames.REVIEWS_LIST} element={<Reviews />} />
                <Route
                  path={Pathnames.APPOINTMENTS_LIST}
                  element={<Appointments />}
                />
                <Route path={Pathnames.CLIENTS_LIST} element={<Clients />} />
                <Route path={Pathnames.REQUESTS_LIST} element={<Requests />} />
                <Route path={Pathnames.CONTACTS_LIST} element={<Contacts />} />
                <Route path={Pathnames.SERVICES_LIST} element={<Services />} />
                <Route path={Pathnames.FAQ_LIST} element={<Faqs />} />
                <Route path={Pathnames.ERROR_LIST} element={<Errors />} />
                <Route path={Pathnames.LOGS_LIST} element={<Logs />} />
                <Route path={Pathnames.USERS_LIST} element={<Users />} />
                <Route
                  path={Pathnames.ESTIMATES_LIST}
                  element={<Estimates />}
                />
                <Route
                  path={Pathnames.PRODUCTS_SERVICES_LIST}
                  element={<Overview />}
                />
                <Route
                  path={Pathnames.PRODUCTS_SERVICES_BUNDLE_LIST}
                  element={<Overview />}
                />
                <Route
                  path={Pathnames.PRODUCTS_SERVICES_CATEGORY_LIST}
                  element={<Overview />}
                />
                <Route
                  path={Pathnames.PRODUCTS_SERVICES_VENDOR_LIST}
                  element={<Overview />}
                />
                <Route path={Pathnames.PROFILE} element={<UserProfile />} />
                <Route
                  path={Pathnames.TEAM_EMPLOYEE_LIST}
                  element={<OverviewTeam />}
                />
                <Route path={Pathnames.TEAMS_LIST} element={<OverviewTeam />} />
                <Route
                  path={Pathnames.EMPLOYEES_LIST}
                  element={<OverviewTeam />}
                />
                <Route path={Pathnames.PROJECTS_LIST} element={<Projects />} />
                <Route
                  path={Pathnames.ACTIVATE_ACCOUNT}
                  element={<ActivationAccount />}
                />
                <Route path={Pathnames.ROLES_LIST} element={<Roles />} />
                <Route path={Pathnames.SETTINGS} element={<Settings />} />
                <Route
                  path={Pathnames.CONTRACTORS_LIST}
                  element={<OverviewTeam />}
                />
                <Route path={Pathnames.TAGS_LIST} element={<OverviewTag />} />
                <Route
                  path={Pathnames.TAG_GROUPS_LIST}
                  element={<OverviewTag />}
                />
                {/* <Route path={Pathnames.EMAIL_LIST} element={< />} />
              <Route path={Pathnames.MESSAGE_LIST} element={< />} /> */}
              </Routes>
            </main>
          </div>
        </div>
      </SearchProvider>
    </>
  );
};

export default Admin;
